/**
 * React Application Entry Point
 *
 * This file:
 * 1. Gets the root div from HTML
 * 2. Creates a React root
 * 3. Renders the App component
 *
 * React 18+ uses createRoot instead of the old ReactDOM.render
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Find the root element in index.html
const rootElement = document.getElementById('root');

// Safety check - should never fail but TypeScript wants it
if (!rootElement) {
  throw new Error(
    'Root element not found. Check that index.html has <div id="root"></div>'
  );
}

// Create React root and render the app
// StrictMode enables extra development checks
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
